import { createSlice } from "@reduxjs/toolkit";
import { HomePageData } from "types/homePage";
import { RootState } from "utils/store";
import { homePageDataApi } from "./homePageApi";

/* =========================================
          initial State           
==========================================*/

const initialState: HomePageData = {
  bpeDetails: [],
  xpeDetails: [],
  dpeDetailsList: [],
  lastRefreshData: "",
};

/* =========================================
            Slice           
==========================================*/
const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(homePageDataApi?.endpoints.getPriceElasticitiesData.matchFulfilled, (state, action) => {
      state.lastRefreshData = action.payload.lastRefreshData;
    });
  },
});

/* =========================================
            Selectors           
==========================================*/
export const stateHomePageData = (state: RootState) => state.homePage;

/* =========================================
            Actions           
==========================================*/
export const { reset } = homePageSlice.actions;

/* =======================================
           Export Reducer  
===========================================*/
export default homePageSlice.reducer;
